import { render, staticRenderFns } from "./resList.vue?vue&type=template&id=34c49aa4&scoped=true&"
import script from "./resList.vue?vue&type=script&lang=js&"
export * from "./resList.vue?vue&type=script&lang=js&"
import style0 from "./resList.vue?vue&type=style&index=0&id=34c49aa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c49aa4",
  null
  
)

export default component.exports